// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1CIVg","gfeWrapper":"CalendarEvent_gfeWrapper__1_Q8O"};